'use client';

import InkRefillLandingPage from './ink-refill/page';

export default function HomePage() {
  return <InkRefillLandingPage />;
}
